import React from 'react';
import * as PlayiitATApi from '../apis/PlayiitATApi.js';
import { ScreenContainer, Touchable, withTheme } from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import {
  ActivityIndicator,
  FlatList,
  Image,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { Fetch } from 'react-request';

const RecentlyAddedScreen = props => {
  const { theme } = props;
  const { navigation } = props;

  const {
    isLoading: screenLoading,
    data: screenData,
    error: screenError,
  } = PlayiitATApi.useFetchAllRecordsGET();

  if (screenLoading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator />
      </View>
    );
  }

  if (screenError) {
    return null;
  }

  if (!screenData) {
    return null;
  }

  return (
    <ScreenContainer hasSafeArea={false} scrollable={true}>
      <View style={styles.ViewRY}>
        <PlayiitATApi.FetchFetchAllRecordsGET>
          {({ loading, error, data, doFetch }) => {
            const fetchData = data;
            if (!fetchData || loading) {
              return <ActivityIndicator />;
            }

            if (error) {
              return (
                <Text style={{ textAlign: 'center' }}>
                  There was a problem fetching this data
                </Text>
              );
            }

            return (
              <FlatList
                data={fetchData?.records}
                renderItem={({ item }) => {
                  const listData = item;
                  return (
                    <View style={styles.View_8p}>
                      <Touchable
                        onPress={() => {
                          try {
                            navigation.navigate('SongdetailScreen', {
                              id: listData?.id,
                            });
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                      >
                        <View
                          style={[
                            styles.ViewUy,
                            { backgroundColor: theme.colors.background },
                          ]}
                        >
                          <View
                            style={[
                              styles.View_68,
                              { backgroundColor: theme.colors.divider },
                            ]}
                          >
                            <Text
                              style={[
                                styles.TextNe,
                                { color: theme.colors.primary },
                              ]}
                            >
                              {listData?.fields &&
                                listData?.fields['Song Name']}
                            </Text>

                            <Text
                              style={[
                                styles.TexthR,
                                { color: theme.colors.medium },
                              ]}
                              numberOfLines={2}
                            >
                              {'By: '}
                              {listData?.fields?.Artist}
                            </Text>

                            <Text
                              style={[
                                styles.Textzk,
                                { color: theme.colors.medium },
                              ]}
                              numberOfLines={2}
                            >
                              {'Date added: '}
                              {listData?.fields &&
                                listData?.fields['Date Added']}
                            </Text>
                          </View>
                          <FlatList
                            data={listData?.fields?.Thumbnail}
                            renderItem={({ item }) => {
                              const listData = item;
                              return (
                                <Image
                                  style={styles.ImagebB}
                                  resizeMode={'cover'}
                                  source={{
                                    uri: `${listData && listData['url']}`,
                                  }}
                                />
                              );
                            }}
                            contentContainerStyle={styles.FlatListWpContent}
                            numColumns={1}
                          />
                        </View>
                      </Touchable>
                    </View>
                  );
                }}
                numColumns={1}
              />
            );
          }}
        </PlayiitATApi.FetchFetchAllRecordsGET>
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  TextNe: {
    fontSize: 18,
  },
  TexthR: {
    fontFamily: 'System',
    fontWeight: '500',
  },
  Textzk: {
    fontFamily: 'System',
    fontWeight: '500',
  },
  View_68: {
    paddingLeft: 8,
    flexGrow: 1,
    flexShrink: 1,
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
    marginTop: 8,
  },
  ImagebB: {
    width: 125,
    height: 75,
  },
  FlatListWpContent: {
    flex: 1,
  },
  ViewUy: {
    flexDirection: 'row',
  },
  View_8p: {
    left: 2,
  },
  ViewRY: {
    width: '100%',
  },
});

export default withTheme(RecentlyAddedScreen);
